import { useColorScheme } from "react-native"
import Colors from "./colors"

type UseColorProps = {
    mode?:'dark'|'light'
}
export const useColors = (props?:UseColorProps) => {
    let color_scheme = props?.mode ?? useColorScheme()
    let absolutes = Colors
    
    let light_theme = {
        absolutes,
        toggle:{
            background: Colors.shades.shade100,
            button: {
                active: Colors.brand.midnight,
                inactive: 'transparent'
            },
            text: {
                active: Colors.shades.white,
                inactive:Colors.brand.slate
            }
        },
        order_book:{
            tradeSide: Colors.brand.electric,
            otherSide: Colors.brand.cyan,
            text: Colors.shades.white,
            selected: Colors.shades.shade600
        },
        buttons: {
            text: {
                success: Colors.shades.white,
                error: Colors.shades.white,
                close: Colors.brand.electric,
                info: Colors.brand.midnight
            },
            borders: {
                success: Colors.utility.success,
                error: Colors.utility.error,
                close: Colors.brand.electric,
                info: Colors.brand.midnight,
            },
            background: {
                success: Colors.utility.success,
                action: Colors.brand.electric,
                error: Colors.utility.error,
                warning: Colors.utility.warning,
                close: Colors.shades.white,
                info: Colors.shades.white,
                squares: Colors.highlights.highlight100,
                competition: Colors.highlights.highlight500
            }
        },
        views: {
            background: Colors.shades.white,
            header: Colors.shades.shade100,
            body: Colors.shades.shade500,
            footer: Colors.shades.shade100,
            gold: Colors.incentive.gold,
            input: Colors.shades.white,
            disabled_input: Colors.shades.shade400,
            blur: 'rgba(242, 245, 247, 0.7)',
            dark_blur: 'rgba(242, 245, 247, 0.9)',
            liquidMarket: Colors.highlights.highlight500Faded,
            illiquidMarket: Colors.shades.shade100
        },
        borders: {
            light: Colors.shades.shade600,
            dark: Colors.accents.accent100,
            input: Colors.shades.shade600

        },
        text: {
            white:Colors.shades.white,
            h1: Colors.brand.midnight,
            h2: Colors.brand.midnight,
            highlight: Colors.brand.cyan,
            description: Colors.brand.midnight,
            descriptionLight: Colors.brand.slate,
            action: Colors.brand.electric,
            input: Colors.shades.black,
            placholder: Colors.shades.shade400,
            warning: Colors.utility.warning,
            success:Colors.utility.success,
            error: Colors.utility.error,
            gold: Colors.incentive.gold,
            silver: Colors.incentive.silver,
            bronze: Colors.incentive.bronze
        }
    }

    let dark_theme = {
        absolutes,
        toggle:{
            background: Colors.shades.blackFadedHeavy,
            button: {
                active: Colors.shades.shade600,
                inactive: 'transparent'
            },
            text: {
                active: Colors.shades.black,
                inactive: Colors.shades.white
            }
        },
        order_book:{
            tradeSide: Colors.brand.electric,
            otherSide: Colors.brand.cyan,
            text: Colors.shades.white,
            selected: Colors.shades.blackFadedHeavy
        },
        buttons: {
            text: {
                success: Colors.shades.white, // #FFFFFF
                error: Colors.shades.white, // #FFFFFF
                close: Colors.brand.electricLight, // **(NEW)** #6CA0E0
                info: Colors.brand.midnightLight, // **(NEW)** #395983
            },
            borders: {
                success: Colors.highlights.highlight400, // #4DBA58
                error: Colors.highlights.highlight300, // #FF4747
                close: Colors.brand.electricLight, // **(NEW)** #6CA0E0
                info: Colors.brand.midnightLight, // **(NEW)** #395983
                
            },
            background: {
                success: Colors.brand.successDark, // **(NEW)** #395B4A
                action: Colors.brand.electricLight,
                error: Colors.brand.errorDark, // **(NEW)** #5A2A2A
                warning: Colors.utility.warning,
                close: Colors.shades.black, // #111111
                info: Colors.shades.black, // #111111,
                squares: Colors.highlights.highlight100Faded, // rgba(98, 10, 255, 0.4)
                competition: Colors.highlights.highlight500Faded, // rgba(5, 164, 189, 0.25)
            },
        },
        views: {
            background: 'rgba(17, 17, 17, 0.9)', // #111111
            header: Colors.shades.blackFadedHeavy, // **(NEW)** #222831
            body: Colors.shades.shade500,
            input: 'rgba(255, 255, 255, 0.05)',
            disabled_input: Colors.shades.black_faded,
            footer: Colors.shades.blackFadedHeavy, // **(NEW)** #222831,
            gold: Colors.incentive.goldDark,
            blur: 'rgba(17, 17, 17, 0.7)',
            dark_blur: 'rgba(17, 17, 17, 0.9)',
            liquidMarket: Colors.highlights.highlight500,
            illiquidMarket: Colors.shades.shade500


        },
        borders: {
            light: Colors.shades.shade500, // Slightly lighter gray for subtle contrast in dark mode
            dark: Colors.accents.accent200, // Deeper accent color for strong contrast
            input: 'rgba(255, 255, 255, 0.1)'
        },
        text: {
            white:Colors.shades.white,
            h1: Colors.shades.white, // #FFFFFF
            h2: Colors.shades.white, // #FFFFFF
            description: Colors.shades.white, // **(NEW)** #B0C4D4
            highlight:Colors.chart.cyan,
            input: Colors.shades.white,
            placholder: Colors.shades.shade500,
            descriptionLight: Colors.brand.slateLight,
            action: Colors.brand.electricLight, // **(NEW)** #6CA0E0
            warning: Colors.utility.warning, // #FCA311
            success: Colors.highlights.highlight400, // Darker green for success text in dark mode
            error: Colors.highlights.highlight300,
            gold: Colors.incentive.goldDark,   // **NEW**: A richer, darker gold for better contrast in dark mode
            silver: Colors.incentive.silverDark, // **NEW**: A muted silver to reduce glare
            bronze: Colors.incentive.bronzeDark,
        }
    };
    const MyColors = color_scheme == 'dark' ? dark_theme : light_theme
    return MyColors
}

